import { computed } from 'vue'
import { formatInTimeZone } from 'date-fns-tz'
import { useTenantSettings } from '@/core/composables'
import {
  formatCalendarDateDisplay,
  formatDatetimeDisplay,
} from '@/core/utils/dateTime'

export const useGymDateDisplay = () => {
  const { dateFormat, timeFormat, timezone } = useTenantSettings()

  const displayDatetimeFormat = computed(() =>
    timeFormat.value === '24h'
      ? `${dateFormat.value} HH:mm`
      : `${dateFormat.value} hh:mm a`,
  )

  const formatPaidAt = (value: string | null | undefined) => {
    if (!value) return '—'

    const trimmed = value.trim()
    if (/^\d{4}-\d{2}-\d{2}$/.test(trimmed)) {
      return formatCalendarDateDisplay(trimmed, dateFormat.value) || '—'
    }

    const instant = new Date(trimmed.replace(' ', 'T'))
    if (Number.isNaN(instant.getTime())) {
      return formatDatetimeDisplay(trimmed, displayDatetimeFormat.value) || '—'
    }

    const tz = timezone.value || 'America/Mexico_City'

    try {
      const timePart = formatInTimeZone(instant, tz, 'HH:mm')
      const formatStr =
        timePart === '00:00' ? dateFormat.value : displayDatetimeFormat.value

      return formatInTimeZone(instant, tz, formatStr) || '—'
    } catch {
      return formatDatetimeDisplay(trimmed, displayDatetimeFormat.value) || '—'
    }
  }

  const formatCalendarDate = (value: string | null | undefined) =>
    value ? formatCalendarDateDisplay(value, dateFormat.value) : '—'

  return {
    formatPaidAt,
    formatCalendarDate,
  }
}
